// @flow

import * as React from 'react';
import styles from './Title.less';

type Props = {
  /** The title content */
  content: string,
};

/**
 * A simple title
 */
const Title = ({ content }: Props) => <p className={styles.title}>{content}</p>;

export default Title;
